import type {
  FamilyDemand,
  WorkshopPlan,
  CreatedSession,
  SessionOptions,
  CreateSessionRequest,
  OccupancySubscription,
} from '@features/workshop-plan/types';

import Routing from '@core/api/routing';
import { baseApi } from '@core/api/base-api';

export const workshopPlanApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWorkshopPlans: builder.query<WorkshopPlan[], void>({
      query: () => ({
        url: Routing.generate('rest_workshop_plan', {}, true),
      }),
      transformResponse: (response: { zones: WorkshopPlan[] }) => response.zones,
    }),
    getFamilyDemand: builder.query<FamilyDemand[], void>({
      query: () => ({
        url: Routing.generate('rest_workshop_families', {}, true),
      }),
      transformResponse: (response: { families: FamilyDemand[] }) => response.families,
      providesTags: ['familyDemand'],
    }),
    getSessionOptions: builder.query<SessionOptions, number>({
      query: (familyId) => ({
        url: Routing.generate('rest_workshop_family_session_options', { family: familyId }, true),
      }),
      keepUnusedDataFor: 0,
      providesTags: ['customizationSessionOptions'],
    }),
    createSession: builder.mutation<CreatedSession, CreateSessionRequest>({
      query: ({ familyId, ...body }) => ({
        url: Routing.generate('rest_workshop_create_session', { family: familyId }, true),
        method: 'POST',
        body,
      }),
      invalidatesTags: ['customizationSessionList'],
    }),
    getOccupancySubscription: builder.query<OccupancySubscription, void>({
      query: () => ({
        url: Routing.generate('rest_workshop_occupancy_subscription', {}, true),
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetWorkshopPlansQuery,
  useGetFamilyDemandQuery,
  useGetSessionOptionsQuery,
  useCreateSessionMutation,
  useLazyGetOccupancySubscriptionQuery,
} = workshopPlanApi;
